/* eslint-disable import/prefer-default-export */
import type { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import type {
  ShadowAccountDetail,
  ShadowNetwork,
  EntityInfo,
  ShadowAccessQueryResp
} from '@src/endpoints/services/graphQueryMgr.service'
// Reducer

export interface PublicObject extends EntityInfo {
  account_name?: string
  actions?: string
  policies?: string[]
}
export interface ShadowNetworkItem extends ShadowNetwork {
  network_ip?: string
  network_name?: string
  account_name?: string
}
export interface ShadowAccountItem extends ShadowAccountDetail {
  account_name?: string
}
export interface ShadowAccess extends ShadowAccessQueryResp {
  unknown_account?: ShadowAccountItem[]
  known_account?: ShadowAccountItem[]
  shadow_network?: ShadowNetworkItem[]
}
export interface UnusedPrivilege {
  Identity?: string
  Type?: string
  URI?: string
  AccountID?: string
  AccountName?: string
  Count?: number
}
export interface UnusedUserRole {
  Name: string
}
export interface RevokeGrant {
  Privilege?: string
}

export type TotalsPublicObjects = { [key in ResourceTypeEnum]?: number }

export const defaultState = {
  publicObjectsList: [] as PublicObject[],
  shadowAccessLists: {} as ShadowAccess,
  unusedUserRoles: [] as UnusedUserRole[],
  totalsPublicObjects: {} as TotalsPublicObjects,
  isPending: false,
  isPendingGraph: true,
  errors: null as any
}

export type ExternalListsState = typeof defaultState
